import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import { Box, CircularProgress, Typography, useTheme } from "@mui/material";
import MilitaryTechIcon from "@mui/icons-material/MilitaryTech";
import { LoyaltyPointType } from "Infrastructure/Api/Api";
import type { ReactNode } from "react";

const getIcon = (pointsType: LoyaltyPointType, color: string): ReactNode => {
  const pointTypeToIconMap: Record<LoyaltyPointType, ReactNode> = {
    [LoyaltyPointType.Stardust]: (
      <AutoAwesomeIcon sx={{ fontSize: 16, color }} />
    ),
    [LoyaltyPointType.Valor]: <MilitaryTechIcon sx={{ fontSize: 18, color }} />,
  };

  return pointTypeToIconMap[pointsType];
};

type Props = {
  colorVariant?: "light" | "dark";
  isLoading?: boolean;
  points?: number;
  pointsType?: LoyaltyPointType;
  dimmed?: boolean;
};

export const LoyaltyPointsCounter = ({
  points = 0,
  isLoading = false,
  colorVariant = "light",
  pointsType = LoyaltyPointType.Stardust,
  dimmed = false,
}: Props) => {
  const theme = useTheme();

  const bgColor = theme.palette.headerWidget[colorVariant].background;
  const color = theme.palette.headerWidget[colorVariant].text;

  const icon = getIcon(pointsType, color);

  return (
    <Box
      display="flex"
      alignItems="center"
      px={3}
      gap={1.5}
      height={40}
      borderRadius={10}
      bgcolor={bgColor}
      minWidth="fit-content"
      sx={{ opacity: dimmed ? 0.5 : 1 }}
    >
      {icon}
      <Typography
        color={color}
        fontSize={14}
        fontWeight={500}
        display="flex"
        alignItems="center"
      >
        {isLoading ? (
          <CircularProgress size={12} sx={{ color: theme.palette.grey[500] }} />
        ) : (
          points
        )}
      </Typography>
    </Box>
  );
};
